export default __webpack_public_path__ + "static/media/ic_launcher.c9b38880.png";